/**
 * ImageRenderer — single inline image with optional caption.
 *
 * Sized to the bubble width with `max-width: 100%`. We don't preload —
 * lazy loading is browser default for off-screen images.
 */
import React from 'react';
import type { ImageContentItem } from '@wg/types';
import type { Renderer } from '../registry';

const ImageRenderer: Renderer = ({ item }) => {
  const it = item as ImageContentItem;
  if (!it.url) return null;
  return (
    <figure className="wg-chat__image">
      <img
        src={it.url}
        alt={it.alt || it.caption || ''}
        loading="lazy"
        decoding="async"
      />
      {it.caption && (
        <figcaption className="wg-chat__image-caption">{it.caption}</figcaption>
      )}
    </figure>
  );
};

export default ImageRenderer;
